<template>

  <v-layout
    row
    wrap
  >
    <v-flex
      xs12
      md8
    >
      <v-card class="pa-3">
        <div class="mb-3" >
          <h1 class="display-1 mb-3">{{ partner.name }}&#x200E; <v-chip color="orange" outline small disabled v-if="partner.recommended"><v-avatar><v-icon>star</v-icon></v-avatar>מומלץ</v-chip><v-chip color="light-green" small disabled text-color="white" v-if="partner.callFirst">ליצור קשר ראשון</v-chip></h1>
          <v-chip
            v-for="(type, index) in partnerTypes"
            :key="type._id"
            :color="type.color || 'grey'"
            text-color="white"
            disabled
          >
            <v-avatar>
              <v-icon>{{ type.icon }}</v-icon>
            </v-avatar>
            {{ type.title }}
          </v-chip>
        </div>

        <vue-markdown
          :source="partner.description || 'אין תיאור'"
          class="markdown"
        ></vue-markdown>

        <div v-if="countries.length">
          <h5 class="subheading font-weight-bold">{{ countries.length > 1 ? "מדינות" : "מדינה" }}</h5>
          <p>{{ countries.map(item => { return item.name }).join(", ") }}</p>
        </div>

        <div v-if="regions.length">
          <h5 class="subheading font-weight-bold">{{ regions.length > 1 ? "איזורים" : "איזור" }}</h5>
          <p>{{ regions.map(item => { return item.name }).join(", ") }}</p>
        </div>
        <!-- <v-btn
            flat
            icon
            @click="edit"
          >
            <v-icon>edit</v-icon>
          </v-btn> -->
      </v-card>
      <v-card class="pa-3 mt-3" v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)">
        <h2>הערות חוקר/ת</h2>
        <vue-markdown
          :source="partner.researcherNotes || 'אין הערות חוקר/ת'"
          class="markdown"
        ></vue-markdown>
      </v-card>
      <partner-check-change-log-card
        v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)"
        :partner-id="partnerId"
      />
      <v-layout
        row
        wrap
        class="ma-3"
      >
        <v-flex
          xs12
          md4
          v-if="partner.relationship"
        >
          <h3 class="body-2 grey--text">סוג הקשר</h3>
          <span class="title">{{ partnerRelationship.title }}</span>
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <h3 class="body-2 grey--text">נוצר בתאריך</h3>
          <span class="title">{{ format(partner.created, 'DD/MM/YYYY') }}</span>
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <h3 class="body-2 grey--text">אימות פרטים</h3>
          <span class="title">{{ format(partner.lastValidation, 'DD/MM/YYYY') }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      md4
    >
      <v-card>
        <v-card-title>
          <h3 class="title">אנשי קשר</h3>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            @click="create"
            v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)"
          >
            <v-icon>add</v-icon> הוספה
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-expansion-panel
          class="elevation-0"
          :value="0"
        >
          <v-expansion-panel-content
            v-for="contact in contacts"
            :key="contact._id"
          >
            <template v-slot:header>
              <span class="title">{{ contact.name }} <v-chip v-if="contact.callFirst" color="light-green" small disabled class="white--text">ליצור קשר ראשון</v-chip></span>
            </template>
            <contact
              :contact="contact"
              :parent-resource="$store.state.resources.partner"
              :parent-id="partnerId"
              :roles="['ADMIN', 'RESEARCHER']"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>

      <partner-events
        :partner-id="partnerId"
        class="mt-3"
      />

    </v-flex>
  </v-layout>
</template>

<script>
import { format } from "date-fns";
import Mixins from "@/mixins/mixins";
import Contact from "../../Contact.vue";
import ContactDetailsList from "../../ContactDetailsList.vue";
import PartnerEvents from "./PartnerEvents.vue";
import PartnerCheckChangeLogCard from "./PartnerCheckChangeLogCard.vue";
import { mapState, mapGetters } from "vuex";
import generateId from "@/idGenerator";
import { cloneDeep } from "lodash";
import VueMarkdown from "vue-markdown";
import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      removing: []
    };
  },
  computed: {
    ...mapState({
      resource: state => state.resources.partner
    }),
    partnerId() {
      return this.$route.params.id;
    },
    partner() {
      return this.$store.getters["entity"]("partners", this.partnerId);
    },
    partnerRelationship() {
      return this.$store.getters["entity"](
        "partnerRelationships",
        this.partner.relationship
      );
    },
    partnerTypes() {
      return this.$store.getters["partners/partnerTypes"](this.partnerId);
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    user() {
      return this.$store.getters["user/user"];
    },
    contacts() {
      let contacts = this.$store.getters["partners/contacts"](this.partnerId);
      let sorted = contacts.sort((a, b) => {
        if (a.callFirst && b.callFirst || !a.callFirst && !b.callFirst) return 0;
        else if (a.callFirst) return -1;
        else if (b.callFirst) return 1;
      })
      return sorted;
    },
    countries() {
      return this.partner.countries.map(item => {
        let country = this.$store.state.entities.countries[item];
        return country;
      }).filter(item => { return !!item })
    },
    regions() {
      return this.partner.regions.map(item => {
        let region = this.$store.state.entities.regions[item];
        return region;
      }).filter(item => { return !!item })
    }
  },
  watch: {},
  mounted() {},
  methods: {
    format,
    shouldShow,
    // onCopySuccess() {
    //   this.$store.dispatch("SHOW_SNACKBAR", {
    //     text: "המידע הועתק",
    //     color: "success"
    //   });
    // },
    // onCopyError(err) {
    //   this.$store.dispatch("SHOW_SNACKBAR", {
    //     text: err.message,
    //     color: "error"
    //   });
    // },
    contactDetails(contactId) {
      // return Object.values(this.$store.state.entities.contactDetails);
      // console.log('contactDetails', contact);
      // let contact = this.$store.state.entities.contacts[contactId];
      // return contact.contactDetails.map(id => this.$store.state.entities.contactDetails[id]);
      return this.$store.getters["partners/contactContactDetails"](contactId);
    },
    languages(contactId) {
      return this.$store.getters["partners/contactLanguages"](contactId);
    },
    languagesList(array) {
      if (array.length) {
        return array
          .map(item => {
            return item.title;
          })
          .reduce(
            (accumulator, currentValue) => accumulator + ", " + currentValue
          );
      } else {
        return "";
      }
    },

    create() {
      let newEntity = { _id: generateId(), partner: this.partnerId };
      this.edit(newEntity, true);
    },
    edit(entity, isNew = false) {
      let resource = this.$store.state.resources.contact;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    },
    remove(contact) {
      this.$set(this.removing, contact._id, true);
      this.$store
        .dispatch("REMOVE_ENTITY", {
          url: "/contacts",
          entityType: "contacts",
          id: contact._id
        })
        .then(() => {
          // this.$store.dispatch("CLEAR_CACHE").then(() => {
          //   this.$store.dispatch("API_GET", {
          //     url: "/partners/" + this.partnerId,
          //     entityType: "partners",
          //     schema: "partnerListSchema"
          //   });
          // });
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "הפריט נמחק",
            color: "success"
          });
        })
        .catch(err => {
          console.log(err.stack);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.$set(this.removing, contact._id, false);
        });
    },
    createContactDetail(contact) {
      let newEntity = { _id: generateId(), contact: contact._id };
      this.editContactDetail(newEntity, true);
    },
    editContactDetail(entity, isNew = false) {
      let resource = this.$store.state.resources.contactDetail;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    }

    // edit() {
    //   this.$store.commit("ADD_EDITABLE_ENTITY", {
    //     entity: this.partner,
    //     schema: "partnerSchema"
    //   });
    //   this.$store.commit("SET_ENTITY_EDIT_DATA", {
    //     id: this.partnerId,
    //     resource: this.resource,
    //     isNew: false
    //   });
    //   this.entityEditDialog = true;
    // },
    // remove() {
    //   this.$store
    //     .dispatch("CLEAR_CACHE")
    //     .then(() => {
    //       return this.$store.dispatch(
    //         "partners/REMOVE_PARTNER",
    //         this.partnerId
    //       );
    //     })
    //     .then()
    //     .catch()
    //     .finally(() => {
    //       this.$router.go(-1);
    //     });
    // },
    // createContactDetail() {
    //   let newEntity = { _id: generateId(), partner: this.partnerId };
    //   this.editContactDetail(newEntity, true);
    // },
    // editContactDetail(entity, isNew = false) {
    //   let resource = this.$store.state.resources.contactDetail;
    //   this.$store.commit("ADD_EDITABLE_ENTITY", {
    //     entity,
    //     schema: resource.schema
    //   });
    //   this.$store.commit("SET_ENTITY_EDIT_DATA", {
    //     id: entity._id,
    //     resource,
    //     isNew
    //   });
    //   this.entityEditDialog = true;
    // },
  },
  components: {
    ContactDetailsList,
    Contact,
    VueMarkdown,
    PartnerEvents,
    PartnerCheckChangeLogCard
  },
  mixins: [Mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.markdown {
  table {
    border: 1px solid #ddd;
  }
  td,
  th {
    text-align: right !important;
    padding: 10px;
    border: 1px solid #ddd;
  }
  tr {
    padding: 5px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partners/partner/GeneralDetails.vue